import axios, { AxiosError, AxiosResponse } from "axios";
import authInstance from "../Keycloak";
import appProps from "../AppConfigContext";
import {
  Banners,
  GenericResponse,
  RequestActualizaDatosPortarLinea,
  RequestActualizarDatosFacturacion,
  RequestActualizarPassword,
  RequestAgregarDatosFacturacion,
  RequestAgregarTarjeta,
  RequestAlias,
  RequestAliasClientAssociated,
  RequestAsociarContrato,
  RequestBitacoraEvento,
  RequestDesasociarContrato,
  RequestEmailnorton,
  RequestForgotPassword,
  RequestObtPDFBase64,
  RequestOperacionSucursalVentas,
  RequestOrdenCompraCancelar,
  RequestOrdenCompraEstatus,
  RequestOrdenCompraGenerar,
  RequestPOSTConvenios,
  RequestPUTConvenios,
  RequestPortarLinea,
  RequestProvision,
  RequestRecharge,
  RequestReferredSendCod,
  RequestSendSmsEdocta,
  RequestUpdateMessage,
  RequestValidarContratacion,
  ResponseAccountStatements,
  ResponseActualizarPassword,
  ResponseAddAndUpdateBillingData,
  ResponseAddAssociatedC,
  ResponseAddPayment,
  ResponseAgregarTarjeta,
  ResponseAlias,
  ResponseAssetsConfig,
  ResponseBillingData,
  ResponseBitacoraEvento,
  ResponseCalls,
  ResponseCallsPeriods,
  ResponseChannel,
  ResponseCisPoints,
  ResponseConsultarTarjetaGral,
  ResponseConsumosGral,
  ResponseContracts,
  ResponseDesasociarContrato,
  ResponseDique,
  ResponseDoPortability,
  ResponseDueDate,
  ResponseEmailnorton,
  ResponseFaqs,
  ResponseForgotPassword,
  ResponseGETConveniosGral,
  ResponseGenerateCode,
  ResponseGenerateToken,
  ResponseGetFacturaPDF,
  ResponseGetListaFacturas,
  ResponseIncognito,
  ResponseListadoPagosGral,
  ResponseMessages,
  ResponseMobilePhoneData,
  ResponseObtPDFBase64,
  ResponseOperacionSucursalVentasGral,
  ResponseOrdenCompraCancelar,
  ResponseOrdenCompraEstatus,
  ResponseOrdenCompraGenerar,
  ResponsePOSTConvenios,
  ResponsePUTConvenios,
  ResponsePayRecharge,
  ResponsePaymentDetails,
  ResponsePaymentGeneral,
  ResponsePaymentsCenters,
  ResponsePaypalId,
  ResponsePopUp,
  ResponseProvision,
  ResponseProxy,
  ResponseRecharges,
  ResponseReferredGenCod,
  ResponseReferredSendCod,
  ResponseReferredValCod,
  ResponseReiniciarEquipo,
  ResponseSendSmsEdocta,
  ResponseSendVerificationCode,
  ResponseSuscriptorData,
  ResponseSuscriptorDataHiredService,
  ResponseTermsAndConditions,
  ResponseUpdateMessage,
  ResponseUpdatePortability,
  ResponseValidarContratacion,
  ResponseValidatePortability,
  ResponseWifiPointsRedesign,
  ResponseDiscounts,
  ResponseRecentPayment,
  ResponsePackAll,
  ActivationProcess,
  ResponsePaymentHasDebt,
  RequestPayWithCardEncrypted,
  ResponseCheckLevelsDTO,
  ResponseRemoveRecurringPayCard,
  ResponseGetSavedCards,
  ResponseRemoveSavedCard,
  RequestRemoveSavedCard,
  ResponsePaymentDataFlp,
  RequestAddCodeUpdateSuscriptor,
  ResponseAddCodeUpdateSuscriptor,
  ResponseUpdateSuscriptor,
  RequestUpdateSuscriptor,
  RequestUpdateCurp,
  ResponseMeganList,
  ResponseMeganQuestion,
  RequestMeganQuestion,
  ResponseShowMegan,
  RequestMeganChat,
  ResponseMeganChat,
  ResponseMeganChatStreamList,
  ResponsePortabilityList,
  RequestHireMegamovil,
  ResponseHireMegamovil,
  ResponseApiTrackingMegamovil,
  ResponseTrackingOt,
  ConfigurableService,
  ResponseCustomizationWifi,
  GeneralResponse,
  RequestUpdateWifi
} from "../types/common";

const instance = axios.create({
  baseURL: appProps.BASE_URL,
});

// Middleware for auth
instance.interceptors.request.use(async (config) => {
  try {
    await authInstance.updateToken(30)
      .then(function (refreshed) {
        if (refreshed) {
          console.log('Token was successfully refreshed');
        }
      })
      .catch(function () {
        console.log('Failed to refresh the token, or the session has expired');
        authInstance.logout();
      });
  } catch (error) {
    console.error("Failed to refresh token");
    authInstance.logout();
  }
  config.headers.Authorization = `Bearer ${authInstance.token}`;
  config.headers["Content-Type"] = "application/json";
  config.headers.Accept = "application/json";
  return config;
});

//---------------------------------------------------------------------------------------------------------------------- General data
//-------------------------------------------------------------------------------------------------- Suscriptor
export const getSuscriptorData = (
  clientId: string
): Promise<GenericResponse<ResponseSuscriptorData>> =>
  new Promise<GenericResponse<ResponseSuscriptorData>>((resolve, reject) => {
    const path = "/general-data/suscriptor-new";

    instance
      .get(path, { params: { idCliente: clientId } })
      .then(
        (response: AxiosResponse<GenericResponse<ResponseSuscriptorData>>) => {
          resolve(response.data);
        }
      )
      .catch((error: AxiosError<any>) => {
        reject(error);
      });
  });

//-------------------------------------------------------------------------------------------------- due date
export const getDueDateApi = (
  clientId: string
): Promise<GenericResponse<ResponseDueDate>> =>
  new Promise<GenericResponse<ResponseDueDate>>((resolve, reject) => {
    const path = "/general-data/due-date-new";

    instance
      .get(path, { params: { idCliente: clientId } })
      .then((response: AxiosResponse<GenericResponse<ResponseDueDate>>) => {
        resolve(response.data);
      })
      .catch((error: AxiosError<any>) => {
        reject(error);
      });
  });

//-------------------------------------------------------------------------------------------------- hired services
export const getHiredServicesClient = (
  clientId: string
): Promise<GenericResponse<ResponseSuscriptorDataHiredService>> =>
  new Promise<GenericResponse<ResponseSuscriptorDataHiredService>>(
    (resolve, reject) => {
      const path = "/general-data/hired-services";

      instance
        .get(path, { params: { idCliente: clientId } })
        .then(
          (
            response: AxiosResponse<
              GenericResponse<ResponseSuscriptorDataHiredService>
            >
          ) => {
            resolve(response.data);
          }
        )
        .catch((error: AxiosError<any>) => {
          reject(error);
        });
    }
  );

//-------------------------------------------------------------------------------------------------- telefonía móvil
export const getMobileData = (
  clientId: string
): Promise<GenericResponse<ResponseMobilePhoneData>> =>
  new Promise<GenericResponse<ResponseMobilePhoneData>>((resolve, reject) => {
    const path = "/general-data/mobile-phone";

    instance
      .get(path, { params: { idCliente: clientId } })
      .then(
        (response: AxiosResponse<GenericResponse<ResponseMobilePhoneData>>) => {
          resolve(response.data);
        }
      )
      .catch((error: AxiosError<any>) => {
        reject(error);
      });
  });

//---------------------------------------------------------------------------------------------------------------------- Messages
//-------------------------------------------------------------------------------------------------- Obtener notificaciones
export const getSuscriptorNotifications = (
  clientId: string
): Promise<GenericResponse<ResponseMessages>> =>
  new Promise<GenericResponse<ResponseMessages>>((resolve, reject) => {
    const path = "/messages/messages";

    instance
      .get(path, { params: { idCliente: clientId } })
      .then((response: AxiosResponse<GenericResponse<ResponseMessages>>) => {
        resolve(response.data);
      })
      .catch((error: AxiosError<any>) => {
        reject(error);
      });
  });

//-------------------------------------------------------------------------------------------------- Update notification
export const updateNotification = (
  body: RequestUpdateMessage,
  clientId: string
): Promise<GenericResponse<ResponseUpdateMessage>> =>
  new Promise<GenericResponse<ResponseUpdateMessage>>((resolve, reject) => {
    const path = "/messages/update-status-message";
    instance
      .put(path, body, { params: { idCliente: clientId } })
      .then(
        (response: AxiosResponse<GenericResponse<ResponseUpdateMessage>>) => {
          resolve(response.data);
        }
      )
      .catch((error: AxiosError<any>) => {
        reject(error);
      });
  });

//---------------------------------------------------------------------------------------------------------------------- Services
//-------------------------------------------------------------------------------------------------- validate portability
export const getValidatePortability = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseValidatePortability>>> => {
  return new Promise<
    AxiosResponse<GenericResponse<ResponseValidatePortability>>
  >((resolve, reject) => {
    const path = "/services/validate-portability";
    instance
      .get(path, { params: { idCliente: idCliente } })
      .then(
        (
          response: AxiosResponse<GenericResponse<ResponseValidatePortability>>
        ) => {
          resolve(response);
        }
      )
      .catch((error: any) => {
        reject(error);
      });
  });
};

//-------------------------------------------------------------------------------------------------- update portability
export const updatePortability = (
  body: RequestActualizaDatosPortarLinea,
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseUpdatePortability>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseUpdatePortability>>>(
    (resolve, reject) => {
      const path = "/services/update-portability";
      instance
        .post(path, body, { params: { idCliente: idCliente } })
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponseUpdatePortability>>
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- do portability
export const doPortability = (
  body: RequestPortarLinea,
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseDoPortability>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseDoPortability>>>(
    (resolve, reject) => {
      const path = "/services/do-portability";
      instance
        .post(path, body, { params: { idCliente: idCliente } })
        .then(
          (response: AxiosResponse<GenericResponse<ResponseDoPortability>>) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- get portability list
export const getPortabilityList = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponsePortabilityList>>> => {
  return new Promise<
    AxiosResponse<GenericResponse<ResponsePortabilityList>>
  >((resolve, reject) => {
    const path = "/services/portability-list";
    instance
      .get(path, { params: { idCliente: idCliente } })
      .then(
        (
          response: AxiosResponse<GenericResponse<ResponsePortabilityList>>
        ) => {
          resolve(response);
        }
      )
      .catch((error: any) => {
        reject(error);
      });
  });
};

//-------------------------------------------------------------------------------------------------- get incognito
export const getIncognito = (
  suscriptor: string
): Promise<AxiosResponse<GenericResponse<ResponseIncognito>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseIncognito>>>(
    (resolve, reject) => {
      const path = "/services/incognito";
      instance
        .get(path, { params: { suscriptor: suscriptor } })
        .then((response: AxiosResponse<GenericResponse<ResponseIncognito>>) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- get dique
export const getDique = (
  suscriptor: string,
  origen: string
): Promise<AxiosResponse<GenericResponse<ResponseDique>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseDique>>>(
    (resolve, reject) => {
      const path = "/services/dique";
      instance
        .get(path, { params: { suscriptor: suscriptor, origen: origen } })
        .then((response: AxiosResponse<GenericResponse<ResponseDique>>) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- check levels
export const checkLevels = (idCliente: string): Promise<AxiosResponse<GenericResponse<ResponseCheckLevelsDTO>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseCheckLevelsDTO>>>(
    (resolve, reject) => {
      const path = "/services/check-levels";
      instance
        .get(path, { params: { idCliente: idCliente } })
        .then((response: AxiosResponse<GenericResponse<ResponseCheckLevelsDTO>>) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- provisioning
export const provisioning = (
  body: RequestProvision
): Promise<AxiosResponse<GenericResponse<ResponseProvision>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseProvision>>>(
    (resolve, reject) => {
      const path = "/services/provision";
      instance
        .post(path, body)
        .then((response: AxiosResponse<GenericResponse<ResponseProvision>>) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- verification code
export const sendVerificationCode = (
  clientId: string,
  typeService: string,
  service: string
): Promise<GenericResponse<ResponseSendVerificationCode>> =>
  new Promise<GenericResponse<ResponseSendVerificationCode>>(
    (resolve, reject) => {
      const path = "/services/send-verification-code";
      instance
        .post(path, null, { params: { idCliente: clientId, typeService: typeService, service: service } })
        .then(
          (
            response: AxiosResponse<
              GenericResponse<ResponseSendVerificationCode>
            >
          ) => {
            resolve(response.data);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );

//-------------------------------------------------------------------------------------------------- servicio norton
export const hireNorton = (
  body: RequestEmailnorton,
  clientId: string
): Promise<GenericResponse<ResponseEmailnorton>> =>
  new Promise<GenericResponse<ResponseEmailnorton>>((resolve, reject) => {
    const path = "/services/hire-norton";
    instance
      .post(path, body, { params: { idCliente: clientId } })
      .then((response: AxiosResponse<GenericResponse<ResponseEmailnorton>>) => {
        resolve(response.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });

//-------------------------------------------------------------------------------------------------- validate suscription
export const validateSubscription = (
  body: RequestValidarContratacion,
  clientId: string
): Promise<GenericResponse<ResponseValidarContratacion>> =>
  new Promise<GenericResponse<ResponseValidarContratacion>>(
    (resolve, reject) => {
      const path = "/services/validate-subscription";
      instance
        .post(path, body, { params: { idCliente: clientId } })
        .then(
          (
            response: AxiosResponse<
              GenericResponse<ResponseValidarContratacion>
            >
          ) => {
            resolve(response.data);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );

//-------------------------------------------------------------------------------------------------- Contratar servicios
export const hireService = (
  body: RequestOperacionSucursalVentas,
  clientId: string
): Promise<GenericResponse<ResponseOperacionSucursalVentasGral>> =>
  new Promise<GenericResponse<ResponseOperacionSucursalVentasGral>>(
    (resolve, reject) => {
      const path = "/services/hire-service";
      instance
        .post(path, body, { params: { idCliente: clientId } })
        .then(
          (
            response: AxiosResponse<
              GenericResponse<ResponseOperacionSucursalVentasGral>
            >
          ) => {
            resolve(response.data);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );

//-------------------------------------------------------------------------------------------------- registrar evento en la bitácora.
export const eventLog = (
  body: RequestBitacoraEvento,
  clientId: string
): Promise<GenericResponse<ResponseBitacoraEvento>> =>
  new Promise<GenericResponse<ResponseBitacoraEvento>>((resolve, reject) => {
    const path = "/services/event-log";
    instance
      .post(path, body, { params: { idCliente: clientId } })
      .then(
        (response: AxiosResponse<GenericResponse<ResponseBitacoraEvento>>) => {
          resolve(response.data);
        }
      )
      .catch((error: any) => {
        reject(error);
      });
  });

//---------------------------------------------------------------------------------------------------------------------- Assets
//-------------------------------------------------------------------------------------------------- Banners

export const getBannersImages = (
  idCliente: string,
  bannerType: string
): Promise<AxiosResponse<GenericResponse<Banners>>> => {
  return new Promise<AxiosResponse<GenericResponse<Banners>>>(
    (resolve, reject) => {
      const path = "/assets/banners-new";
      instance
        // TODO: Cambiar el parametro de APP a SEL ya que se tenga en el backend
        .get(path, { params: { idCliente, bannerType, serviceType: "APP" } })
        .then((response: AxiosResponse<GenericResponse<Banners>>) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

export const getPopup = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponsePopUp>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponsePopUp>>>(
    (resolve, reject) => {
      const path = "/assets/pop-up";
      instance
        .get(path, { params: { idCliente } })
        .then((response: AxiosResponse<GenericResponse<ResponsePopUp>>) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//---------------------------------------------------------------------------------------------------------------------- Payments
//-------------------------------------------------------------------------------------------------- last payments
export const getLastPayments = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseListadoPagosGral>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseListadoPagosGral>>>(
    (resolve, reject) => {
      const path = "/payments/last-payments";
      instance
        .get(path, { params: { idCliente: idCliente } })
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponseListadoPagosGral>>
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

export const getPaymentsHasDebt = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponsePaymentHasDebt>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponsePaymentHasDebt>>>(
    (resolve, reject) => {
      const path = "/payments/payments-has-debt";
      instance
        .get(path, { params: { idCliente: idCliente } })
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponsePaymentHasDebt>>
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- payments general
export const getPaymentsGeneral = (
  idCliente: string
): Promise<GenericResponse<ResponsePaymentGeneral>> => {
  return new Promise<GenericResponse<ResponsePaymentGeneral>>(
    (resolve, reject) => {
      const path = "/payments/payments-general";
      instance
        .get(path, { params: { idCliente: idCliente } })
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponsePaymentGeneral>>
          ) => {
            resolve(response.data);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- get card
export const getPaymentsSavedCard = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseConsultarTarjetaGral>>> => {
  return new Promise<
    AxiosResponse<GenericResponse<ResponseConsultarTarjetaGral>>
  >((resolve, reject) => {
    const path = "/payments/get-card";
    instance
      .post(path, null, { params: { idCliente: idCliente } })
      .then(
        (
          response: AxiosResponse<GenericResponse<ResponseConsultarTarjetaGral>>
        ) => {
          resolve(response);
        }
      )
      .catch((error: any) => {
        reject(error);
      });
  });
};

//-------------------------------------------------------------------------------------------------- get payments centers
export const getPaymentsCenters = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponsePaymentsCenters>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponsePaymentsCenters>>>(
    (resolve, reject) => {
      const path = "/payments/payments-centers";
      instance
        .get(path, { params: { idCliente: idCliente } })
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponsePaymentsCenters>>
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- get cis points
export const getCisPoint = (
  idCliente: string,
  latitude: string,
  longitud: string
): Promise<AxiosResponse<GenericResponse<Array<ResponseCisPoints>>>> => {
  return new Promise<AxiosResponse<GenericResponse<Array<ResponseCisPoints>>>>(
    (resolve, reject) => {
      const path = "/payments/cis-point";
      instance
        .get(path, {
          params: {
            latitude: latitude,
            longitud: longitud,
            idCliente: idCliente,
          },
        })
        .then(
          (
            response: AxiosResponse<GenericResponse<Array<ResponseCisPoints>>>
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- Método para saber si el cliente cuenta con domiciliacion activa
export const getExpirationCard = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseGETConveniosGral>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseGETConveniosGral>>>(
    (resolve, reject) => {
      const path = "/payments/expiration-card";
      instance
        .get(path, { params: { idCliente: idCliente } })
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponseGETConveniosGral>>
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- Método para actualizar tarjeta domiciliada.
export const updateExpCard = (
  body: RequestPUTConvenios,
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponsePUTConvenios>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponsePUTConvenios>>>(
    (resolve, reject) => {
      const path = "/payments/update-expiration-card";
      instance
        .put(path, body, { params: { idCliente: idCliente } })
        .then(
          (response: AxiosResponse<GenericResponse<ResponsePUTConvenios>>) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- Método para agregar tarjeta a domiciliar
export const addCard = (
  body: RequestPOSTConvenios,
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponsePOSTConvenios>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponsePOSTConvenios>>>(
    (resolve, reject) => {
      const path = "/payments/add-card";
      instance
        .post(path, body, { params: { idCliente: idCliente } })
        .then(
          (response: AxiosResponse<GenericResponse<ResponsePOSTConvenios>>) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- Método para Agregar/Actualizar tarjeta de un suscriptor
export const saveCard = (
  body: RequestAgregarTarjeta,
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseAgregarTarjeta>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseAgregarTarjeta>>>(
    (resolve, reject) => {
      const path = "/payments/save-card";
      instance
        .post(path, body, { params: { idCliente: idCliente } })
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponseAgregarTarjeta>>
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- Método para encriptar una tarjeta.
export const encryptCreditCard = (
  idCliente: string,
  creditCard: string
): Promise<AxiosResponse<GenericResponse<any>>> => {
  return new Promise<AxiosResponse<GenericResponse<any>>>((resolve, reject) => {
    const path = "/payments/encrypt-credit-card";
    instance
      .get(path, { params: { idCliente: idCliente, creditCard: creditCard } })
      .then((response: AxiosResponse<GenericResponse<any>>) => {
        resolve(response);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

//-------------------------------------------------------------------------------------------------- Método para desencriptar una tarjeta.
export const dencryptCreditCard = (
  idCliente: string,
  creditCard: string
): Promise<AxiosResponse<GenericResponse<any>>> => {
  return new Promise<AxiosResponse<GenericResponse<any>>>((resolve, reject) => {
    const path = "/payments/dencrypt-credit-card";
    instance
      .get(path, { params: { idCliente: idCliente, creditCard: creditCard } })
      .then((response: AxiosResponse<GenericResponse<any>>) => {
        resolve(response);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

//-------------------------------------------------------------------------------------------------- Método para pagar con tarjeta
export const payWithCard = (
  body: RequestPayWithCardEncrypted,
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseProxy>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseProxy>>>(
    (resolve, reject) => {
      const path = "/payments/pay-with-card-encrypted";
      instance
        .post(path, body, { params: { idCliente: idCliente } })
        .then((response: AxiosResponse<GenericResponse<ResponseProxy>>) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- get account statements
export const getAccountStatements = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseAccountStatements>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseAccountStatements>>>(
    (resolve, reject) => {
      const path = "payments/account-statements";
      instance
        .get(path, { params: { idCliente: idCliente } })
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponseAccountStatements>>
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//---------------------------------------------------------------------------------------------------------------------- Paypal
//-------------------------------------------------------------------------------------------------- get paypal client
export const paypalId = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponsePaypalId>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponsePaypalId>>>(
    (resolve, reject) => {
      const path = "/paypal/paypal-id";
      instance
        .post(path, null, { params: { idCliente: idCliente } })
        .then((response: AxiosResponse<GenericResponse<ResponsePaypalId>>) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- Metodo para generar orden de pago con Paypal
export const paypalGenerate = (
  body: RequestOrdenCompraGenerar,
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseOrdenCompraGenerar>>> => {
  return new Promise<
    AxiosResponse<GenericResponse<ResponseOrdenCompraGenerar>>
  >((resolve, reject) => {
    const path = "/paypal/generate-order";
    instance
      .post(path, body, { params: { idCliente: idCliente } })
      .then(
        (
          response: AxiosResponse<GenericResponse<ResponseOrdenCompraGenerar>>
        ) => {
          resolve(response);
        }
      )
      .catch((error: any) => {
        reject(error);
      });
  });
};

//-------------------------------------------------------------------------------------------------- Método para obtener el estado de la orden de pago por paypal.
export const paypalStatus = (
  body: RequestOrdenCompraEstatus,
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseOrdenCompraEstatus>>> => {
  return new Promise<
    AxiosResponse<GenericResponse<ResponseOrdenCompraEstatus>>
  >((resolve, reject) => {
    const path = "/paypal/order-status";
    instance
      .post(path, body, { params: { idCliente: idCliente } })
      .then(
        (
          response: AxiosResponse<GenericResponse<ResponseOrdenCompraEstatus>>
        ) => {
          resolve(response);
        }
      )
      .catch((error: any) => {
        reject(error);
      });
  });
};

//-------------------------------------------------------------------------------------------------- Método para cancelar la orden de pago por paypal.
export const paypalCancel = (
  body: RequestOrdenCompraCancelar,
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseOrdenCompraCancelar>>> => {
  return new Promise<
    AxiosResponse<GenericResponse<ResponseOrdenCompraCancelar>>
  >((resolve, reject) => {
    const path = "/paypal/order-cancel";
    instance
      .post(path, body, { params: { idCliente: idCliente } })
      .then(
        (
          response: AxiosResponse<GenericResponse<ResponseOrdenCompraCancelar>>
        ) => {
          resolve(response);
        }
      )
      .catch((error: any) => {
        reject(error);
      });
  });
};

//---------------------------------------------------------------------------------------------------------------------- Mobil telephony
//-------------------------------------------------------------------------------------------------- // Método para agregar recarga
export const addPayment = (
  idCliente: string,
  payType: string,
  reference: string,
  amount: string,
  phone: string
): Promise<AxiosResponse<GenericResponse<ResponseAddPayment>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseAddPayment>>>(
    (resolve, reject) => {
      const path = "/mobile/add-payment";
      instance
        .get(path, { params: { idCliente, payType, reference, amount, phone } })
        .then(
          (response: AxiosResponse<GenericResponse<ResponseAddPayment>>) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- Obtener el consumo
export const getDataUsage = (
  phoneNumber: string,
  clientId: string
): Promise<AxiosResponse<GenericResponse<ResponseConsumosGral>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseConsumosGral>>>(
    (resolve, reject) => {
      const path = "/mobile/data-usage";
      instance
        .get(path, { params: { phone: phoneNumber, idCliente: clientId } })
        .then(
          (response: AxiosResponse<GenericResponse<ResponseConsumosGral>>) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- Obtener el historial de recargas
export const getRefillsHistory = (
  phoneNumber: string,
  clientId: string
): Promise<GenericResponse<ResponsePaymentDetails>> => {
  return new Promise<GenericResponse<ResponsePaymentDetails>>(
    (resolve, reject) => {
      const path = "/mobile/history";
      instance
        .get(path, { params: { phone: phoneNumber, idCliente: clientId } })
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponsePaymentDetails>>
          ) => {
            resolve(response.data);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- Obtener recargas disponibles
export const getRecharges = (
  phoneNumber: string,
  clientId: string
): Promise<GenericResponse<ResponseRecharges>> => {
  return new Promise<GenericResponse<ResponseRecharges>>((resolve, reject) => {
    const path = "/mobile/recharges";
    instance
      .get(path, { params: { numero: phoneNumber, idCliente: clientId } })
      .then((response: AxiosResponse<GenericResponse<ResponseRecharges>>) => {
        resolve(response.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

//-------------------------------------------------------------------------------------------------- Efectuar una recarga
export const doRecharge = (
  clientId: string,
  body: RequestRecharge
): Promise<GenericResponse<ResponsePayRecharge>> => {
  return new Promise<GenericResponse<ResponsePayRecharge>>(
    (resolve, reject) => {
      const path = "/mobile/pay-recharge";
      instance
        .post(path, body, { params: { idCliente: clientId } })
        .then(
          (response: AxiosResponse<GenericResponse<ResponsePayRecharge>>) => {
            resolve(response.data);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//---------------------------------------------------------------------------------------------------------------------- Support

export const getShowMegan = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseShowMegan>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseShowMegan>>>(
    (resolve, reject) => {
      const path = "/support/show-megan";
      instance
        .get(path, {
          params: {
            idCliente: idCliente,
          },
        })
        .then((response: AxiosResponse<GenericResponse<ResponseShowMegan>>) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- get megan faqs
export const getMeganFaqs = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseMeganList>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseMeganList>>>(
    (resolve, reject) => {
      const path = "/support/megan-list";
      instance
        .get(path, {
          params: {
            idCliente: idCliente,
          },
        })
        .then((response: AxiosResponse<GenericResponse<ResponseMeganList>>) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- Post Megan Question
export const postMeganQuestion = (
  idCliente: string,
  body: RequestMeganQuestion
): Promise<AxiosResponse<GenericResponse<ResponseMeganQuestion>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseMeganQuestion>>>(
    (resolve, reject) => {
      const path = "/support/megan-question";
      instance
        .post(path, body, { params: { idCliente: idCliente } })
        .then((response: AxiosResponse<GenericResponse<ResponseMeganQuestion>>) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- Post Megan Chat
export const postMeganChat = (
  body: RequestMeganChat
): Promise<AxiosResponse<ResponseMeganChat>> => {
  return new Promise<AxiosResponse<ResponseMeganChat>>((resolve, reject) => {
    const path = "/support/megan-chat";
    instance
      .post(path, body)
      .then((response: AxiosResponse<ResponseMeganChat>) => {
        resolve(response);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

//-------------------------------------------------------------------------------------------------- Stream Megan Chat
export const streamMeganChat = (
  body: RequestMeganChat
): Promise<AxiosResponse<ResponseMeganChatStreamList>> => {
  return new Promise<AxiosResponse<ResponseMeganChatStreamList>>(
    (resolve, reject) => {
      const path = "/support/megan-chat-stream";
      instance
        .post(path, body)
        .then((response: AxiosResponse<ResponseMeganChatStreamList>) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- get all faqs
export const getAllFaqs = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseFaqs>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseFaqs>>>(
    (resolve, reject) => {
      const path = "/support/faqs-all";
      instance
        .get(path, {
          params: {
            idCliente: idCliente,
          },
        })
        .then((response: AxiosResponse<GenericResponse<ResponseFaqs>>) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- get channels
export const getChannelList = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseChannel>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseChannel>>>(
    (resolve, reject) => {
      const path = "/support/channel-list";
      instance
        .get(path, {
          params: {
            idCliente: idCliente,
          },
        })
        .then((response: AxiosResponse<GenericResponse<ResponseChannel>>) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- reset signal
export const resetSignal = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseReiniciarEquipo>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseReiniciarEquipo>>>(
    (resolve, reject) => {
      const path = "/support/reset-signal";
      instance
        .post(path, null, { params: { idCliente: idCliente } })
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponseReiniciarEquipo>>
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- get wifi points
export const getWifiPoint = (
  idCliente: string,
  latitude: string,
  longitud: string
): Promise<
  AxiosResponse<GenericResponse<Array<ResponseWifiPointsRedesign>>>
> => {
  return new Promise<
    AxiosResponse<GenericResponse<Array<ResponseWifiPointsRedesign>>>
  >((resolve, reject) => {
    const path = "/support/wifi-point";
    instance
      .get(path, {
        params: {
          latitude: latitude,
          longitud: longitud,
          idCliente: idCliente,
        },
      })
      .then(
        (
          response: AxiosResponse<
            GenericResponse<Array<ResponseWifiPointsRedesign>>
          >
        ) => {
          resolve(response);
        }
      )
      .catch((error: any) => {
        reject(error);
      });
  });
};

//---------------------------------------------------------------------------------------------------------------------- terms and conditions
//-------------------------------------------------------------------------------------------------- get terms and conditions
export const getTermsAndCond = async (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseTermsAndConditions>>> => {
  return new Promise<
    AxiosResponse<GenericResponse<ResponseTermsAndConditions>>
  >((resolve, reject) => {
    const path = "/terms-and-conditions";
    instance
      .get(path, { params: { idCliente: idCliente } })
      .then(
        (
          response: AxiosResponse<GenericResponse<ResponseTermsAndConditions>>
        ) => {
          resolve(response);
        }
      )
      .catch((error: any) => {
        reject(error);
      });
  });
};

//---------------------------------------------------------------------------------------------------------------------- Invoice
//-------------------------------------------------------------------------------------------------- get invoice data
export const getInvoiceData = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseBillingData>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseBillingData>>>(
    (resolve, reject) => {
      const path = "/invoice/data";
      instance
        .post(path, null, { params: { idCliente: idCliente } })
        .then(
          (response: AxiosResponse<GenericResponse<ResponseBillingData>>) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

// Método para actualizar los datos de facturación.
export const updateBillingData = (
  body: RequestActualizarDatosFacturacion,
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseAddAndUpdateBillingData>>> => {
  return new Promise<
    AxiosResponse<GenericResponse<ResponseAddAndUpdateBillingData>>
  >((resolve, reject) => {
    const path = "/invoice/update-data";
    instance
      .post(path, body, { params: { idCliente: idCliente } })
      .then(
        (
          response: AxiosResponse<
            GenericResponse<ResponseAddAndUpdateBillingData>
          >
        ) => {
          resolve(response);
        }
      )
      .catch((error: any) => {
        reject(error);
      });
  });
};

// Método para agregar los datos de facturación.
export const addBillingData = (
  body: RequestAgregarDatosFacturacion,
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseAddAndUpdateBillingData>>> => {
  return new Promise<
    AxiosResponse<GenericResponse<ResponseAddAndUpdateBillingData>>
  >((resolve, reject) => {
    const path = "/invoice/add-data";
    instance
      .post(path, body, { params: { idCliente: idCliente } })
      .then(
        (
          response: AxiosResponse<
            GenericResponse<ResponseAddAndUpdateBillingData>
          >
        ) => {
          resolve(response);
        }
      )
      .catch((error: any) => {
        reject(error);
      });
  });
};

//-------------------------------------------------------------------------------------------------- get billing data
export const getBillingData = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseGetListaFacturas>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseGetListaFacturas>>>(
    (resolve, reject) => {
      const path = "/invoice/get-invoices";
      instance
        .get(path, { params: { idCliente: idCliente } })
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponseGetListaFacturas>>
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- get billing pdf
export const getBillingPDF = (
  emisor: string,
  serie: string,
  folio: string
): Promise<AxiosResponse<GenericResponse<ResponseGetFacturaPDF>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseGetFacturaPDF>>>(
    (resolve, reject) => {
      const path = "/invoice/billing-pdf";
      instance
        .get(path, {
          params: {
            emisor: emisor,
            serie: serie,
            folio: folio,
          },
        })
        .then(
          (response: AxiosResponse<GenericResponse<ResponseGetFacturaPDF>>) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- download pdf statement
export const downloadPdfStatement = (
  body: RequestObtPDFBase64,
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseObtPDFBase64>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseObtPDFBase64>>>(
    (resolve, reject) => {
      const path = "/statements/download-pdf-statement";
      instance
        .post(path, body, { params: { idCliente: idCliente } })
        .then(
          (response: AxiosResponse<GenericResponse<ResponseObtPDFBase64>>) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

export const getPaymentsGeneralWithCache = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponsePaymentGeneral>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponsePaymentGeneral>>>(
    (resolve, reject) => {
      const path = "/payments/payments-general-with-cache";
      instance
        .get(path, { params: { idCliente: idCliente } })
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponsePaymentGeneral>>
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

export const getPaymentDataFlp = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponsePaymentDataFlp>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponsePaymentDataFlp>>>(
    (resolve, reject) => {
      const path = "/payments/payment-data-flp";
      instance
        .get(path, { params: { idCliente: idCliente } })
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponsePaymentDataFlp>>
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- history call
export const getPeriodsCalls = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseCallsPeriods>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseCallsPeriods>>>(
    (resolve, reject) => {
      const path = "/history-calls/periods";
      instance
        .get(path, { params: { idCliente: idCliente } })
        .then(
          (response: AxiosResponse<GenericResponse<ResponseCallsPeriods>>) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

export const getCallsHistory = (
  idCliente: string,
  startDate: string,
  endDate: string,
  callType: string
): Promise<AxiosResponse<GenericResponse<ResponseCalls>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseCalls>>>(
    (resolve, reject) => {
      const path = "/history-calls/calls";
      instance
        .get(path, { params: { idCliente, startDate, endDate, callType } })
        .then((response: AxiosResponse<GenericResponse<ResponseCalls>>) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//---------------------------------------------------------------------------------------------------------------------- password
//-------------------------------------------------------------------------------------------------- update password

export const forgotPassword = (
  body: RequestForgotPassword,
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseForgotPassword>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseForgotPassword>>>(
    (resolve, reject) => {
      const path = "/password/forgot-password";
      instance
        .post(path, body, { params: { idCliente: idCliente } })
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponseForgotPassword>>
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

export const updatePassword = (
  body: RequestActualizarPassword
): Promise<AxiosResponse<GenericResponse<ResponseActualizarPassword>>> => {
  return new Promise<
    AxiosResponse<GenericResponse<ResponseActualizarPassword>>
  >((resolve, reject) => {
    const path = "/password/update-password";
    instance
      .post(path, body)
      .then(
        (
          response: AxiosResponse<GenericResponse<ResponseActualizarPassword>>
        ) => {
          resolve(response);
        }
      )
      .catch((error: any) => {
        reject(error);
      });
  });
};

export const sendStatementBySms = (
  body: RequestSendSmsEdocta,
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseSendSmsEdocta>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseSendSmsEdocta>>>(
    (resolve, reject) => {
      const path = "/statements/send-statement-by-sms";
      instance
        .post(path, body, { params: { idCliente: idCliente } })
        .then(
          (response: AxiosResponse<GenericResponse<ResponseSendSmsEdocta>>) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//---------------------------------------------------------------------------------------------------------------------- contracts
//-------------------------------------------------------------------------------------------------- get contracts

export const getContracts = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseContracts>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseContracts>>>(
    (resolve, reject) => {
      const path = "/contracts/contracts";
      instance
        .get(path, { params: { idCliente } })
        .then((response: AxiosResponse<GenericResponse<ResponseContracts>>) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

export const removeAssociatedC = (
  body: RequestDesasociarContrato,
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseDesasociarContrato>>> => {
  return new Promise<
    AxiosResponse<GenericResponse<ResponseDesasociarContrato>>
  >((resolve, reject) => {
    const path = "/contracts/remove-contract";
    instance
      .post(path, body, { params: { idCliente: idCliente } })
      .then(
        (
          response: AxiosResponse<GenericResponse<ResponseDesasociarContrato>>
        ) => {
          resolve(response);
        }
      )
      .catch((error: any) => {
        reject(error);
      });
  });
};

export const addAssociatedC = (
  body: RequestAsociarContrato,
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseAddAssociatedC>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseAddAssociatedC>>>(
    (resolve, reject) => {
      const path = "/contracts/add-contract";
      instance
        .post(path, body, { params: { idCliente: idCliente } })
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponseAddAssociatedC>>
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

export const updateAliasRoot = (
  body: RequestAlias,
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseAlias>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseAlias>>>(
    (resolve, reject) => {
      const path = "/suscriptor/update-alias";
      instance
        .put(path, body, { params: { idCliente: idCliente } })
        .then((response: AxiosResponse<GenericResponse<ResponseAlias>>) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

export const updateAliasAssociated = (
  body: RequestAliasClientAssociated,
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseAlias>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseAlias>>>(
    (resolve, reject) => {
      const path = "/suscriptor/update-alias-associated";
      instance
        .put(path, body, { params: { idCliente: idCliente } })
        .then((response: AxiosResponse<GenericResponse<ResponseAlias>>) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

// Metodo para generar un codigo de referido
export const referredGenCode = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseReferredGenCod>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseReferredGenCod>>>(
    (resolve, reject) => {
      const path = "/referred/generate-code";
      instance
        .get(path, { params: { idCliente } })
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponseReferredGenCod>>
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

// Metodo para envíar un codigo de referido
export const referredSendCode = (
  body: RequestReferredSendCod,
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseReferredSendCod>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseReferredSendCod>>>(
    (resolve, reject) => {
      const path = "/referred/send-code";
      instance
        .post(path, body, { params: { idCliente } })
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponseReferredSendCod>>
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

// Metodo para validar un codigo de referido
export const referredValidateCode = (
  codigo: string,
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseReferredValCod>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseReferredValCod>>>(
    (resolve, reject) => {
      const path = "/referred/validate-code";
      instance
        .get(path, { params: { codigo, idCliente } })
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponseReferredValCod>>
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

// Metodo para obtener el Reporte de descuentos aplicados
export const referredReportDiscounts = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseDiscounts>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseDiscounts>>>(
    (resolve, reject) => {
      const path = "/referred/discounts";
      instance
        .post(path, null, { params: { idCliente: idCliente } })
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponseDiscounts>>
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        })
    }
  )
};

// Metodo para obtener si existen pagos recientes
export const getRecentPayment = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseRecentPayment>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseRecentPayment>>>(
    (resolve, reject) => {
      const path = "/payments/get-recent-payment";
      instance
        .get(path, { params: { idCliente: idCliente } })
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponseRecentPayment>>
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        })
    }
  )
};

export const getGetSavedCards = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseGetSavedCards>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseGetSavedCards>>>(
    (resolve, reject) => {
      const path = "/payments/get-saved-card-list";
      instance
        .get(path, { params: { idCliente: idCliente } })
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponseGetSavedCards>>
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

export const removeSavedCard = (
  body: RequestRemoveSavedCard,
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseRemoveSavedCard>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseRemoveSavedCard>>>(
    (resolve, reject) => {
      const path = "/payments/remove-saved-card";
      instance
        .post(path, body, { params: { idCliente } })
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponseRemoveSavedCard>>
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

// Metodo assets configuration
export const getAssetsConfig = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseAssetsConfig>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseAssetsConfig>>>(
    (resolve, reject) => {
      const path = "/assets-config/configuration";
      instance
        .get(path, { params: { idCliente } })
        .then(
          (response: AxiosResponse<GenericResponse<ResponseAssetsConfig>>) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- Método para obtener los servicios y activaciones.
export const validateAllServices = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponsePackAll>>> =>
  new Promise<AxiosResponse<GenericResponse<ResponsePackAll>>>(
    (resolve, reject) => {
      const path = "/pack/validate-all";
      instance
        .post(path, null, { params: { idCliente: idCliente } })
        .then(
          (
            response: AxiosResponse<
              GenericResponse<ResponsePackAll>
            >
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );

//-------------------------------------------------------------------------------------------------- Método para obtener url de activacion de servicios contratados
export const postGenerateAllTokens = (
  process: ActivationProcess,
  clientId: string,
  code?: string
): Promise<AxiosResponse<GenericResponse<ResponseGenerateToken>>> =>
  new Promise<AxiosResponse<GenericResponse<ResponseGenerateToken>>>((resolve, reject) => {
    const path = "/pack/generate-token/" + process;

    instance
      .post(path, null, { params: { clientId: clientId, ...(code && { code }) } })
      .then(
        (response: AxiosResponse<GenericResponse<ResponseGenerateToken>>) => {
          resolve(response);
        }
      )
      .catch((error: any) => {
        reject(error);
      });
  });

//-------------------------------------------------------------------------------------------------- Método para obtener el Codigo NFL o MLB
export const postGenerateAllCodes = (
  process: ActivationProcess,
  clientId: string
): Promise<AxiosResponse<GenericResponse<ResponseGenerateCode>>> =>
  new Promise<AxiosResponse<GenericResponse<ResponseGenerateCode>>>((resolve, reject) => {
    const path = "/pack/generate-code/" + process;
    instance
      .post(path, null, { params: { idCliente: clientId } })
      .then(
        (response: AxiosResponse<GenericResponse<ResponseGenerateCode>>) => {
          resolve(response);
        }
      )
      .catch((error: any) => {
        reject(error);
      });
  });

export const removeRecurringSavedCard = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseRemoveRecurringPayCard>>> => {
  return new Promise<AxiosResponse<GenericResponse<ResponseRemoveRecurringPayCard>>>(
    (resolve, reject) => {
      const path = "/payments/remove-recurring-saved-card";
      instance
        .get(path, { params: { idCliente } })
        .then(
          (
            response: AxiosResponse<GenericResponse<ResponseRemoveRecurringPayCard>>
          ) => {
            resolve(response);
          }
        )
        .catch((error: any) => {
          reject(error);
        });
    }
  );
};

//-------------------------------------------------------------------------------------------------- Método para enviar sms con codigo de verificacion para actualizar datos
export const sendCodeUpdateSuscriptor = (
  body: RequestAddCodeUpdateSuscriptor,
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseAddCodeUpdateSuscriptor>>> =>
  new Promise<AxiosResponse<GenericResponse<ResponseAddCodeUpdateSuscriptor>>>((resolve, reject) => {
    const path = "/suscriptor-data/send-code";
    instance
      .post(path, body, { params: { idCliente: idCliente } })
      .then(
        (response: AxiosResponse<GenericResponse<ResponseAddCodeUpdateSuscriptor>>) => {
          resolve(response);
        }
      )
      .catch((error: any) => {
        reject(error);
      });
  });

//-------------------------------------------------------------------------------------------------- Método para actualizar datos
export const updateSuscriptor = (
  body: RequestUpdateSuscriptor,
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseUpdateSuscriptor>>> =>
  new Promise<AxiosResponse<GenericResponse<ResponseUpdateSuscriptor>>>((resolve, reject) => {
    const path = "/suscriptor-data/update";
    instance
      .post(path, body, { params: { idCliente: idCliente } })
      .then(
        (response: AxiosResponse<GenericResponse<ResponseUpdateSuscriptor>>) => {
          resolve(response);
        }
      )
      .catch((error: any) => {
        reject(error);
      });
  });

//-------------------------------------------------------------------------------------------------- Metodo para actualizar la CURP del suscriptor
export const updateCurp = (
  body: RequestUpdateCurp
): Promise<AxiosResponse<GenericResponse<ResponseProvision>>> =>
  new Promise<AxiosResponse<GenericResponse<ResponseProvision>>>((resolve, reject) => {
    const path = "/suscriptor/update-curp";
    instance
      .post(path, body)
      .then((response: AxiosResponse<GenericResponse<ResponseProvision>>) => {
        resolve(response);
      })
      .catch((error: any) => {
        reject(error);
      });
  });

//--------------------------------------------------------------------------------------------------Método para contratar mega movil
export const hireMegaMovil = (
  body: RequestHireMegamovil,
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseHireMegamovil>>> =>
  new Promise<AxiosResponse<GenericResponse<ResponseHireMegamovil>>>((resolve, reject) => {
    const path = "/pack/hire-megamovil";
    instance
      .post(path, body, { params: { idCliente: idCliente } })
      .then(
        (response: AxiosResponse<GenericResponse<ResponseHireMegamovil>>) => {
          resolve(response);
        }
      )
      .catch((error: any) => {
        reject(error);
      });
  });

//-------------------------------------------------------------------------------------------------- Método para seguimiento de estatus mega movil
export const trackingMegamovil = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseApiTrackingMegamovil>>> =>
  new Promise<AxiosResponse<GenericResponse<ResponseApiTrackingMegamovil>>>((resolve, reject) => {
    const path = "/pack/tracking-megamovil";
    instance
      .get(path, { params: { idCliente: idCliente } })
      .then(
        (response: AxiosResponse<GenericResponse<ResponseApiTrackingMegamovil>>) => {
          resolve(response);
        }
      )
      .catch((error: any) => {
        reject(error);
      });
  });

//-------------------------------------------------------------------------------------------------- Método para seguimiento de estatus de ordenes de servicio
export const getTrackingOt = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseTrackingOt>>> =>
  new Promise<AxiosResponse<GenericResponse<ResponseTrackingOt>>>((resolve, reject) => {
    const path = "/pack/tracking-ot";
    instance
      .get(path, { params: { idCliente: idCliente } })
      .then(
        (response: AxiosResponse<GenericResponse<ResponseTrackingOt>>) => {
          resolve(response);
        }
      )
      .catch((error: any) => {
        reject(error);
      });
  });

//-------------------------------------------------------------------------------------------------- Método para creacion y envio de factura
export const postGenerateInvoice = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<GeneralResponse>>> =>
  new Promise<AxiosResponse<GenericResponse<GeneralResponse>>>((resolve, reject) => {
    const path = "/invoice/generate-and-send";
    instance
      .post(path, { params: { idCliente: idCliente } })
      .then(
        (response: AxiosResponse<GenericResponse<GeneralResponse>>) => {
          resolve(response);
        }
      )
      .catch((error: any) => {
        reject(error);
      });
  });

//-------------------------------------------------------------------------------------------------- Método para obtener la lista de servicios configurables

export const getListConfigurableService = (): Promise<AxiosResponse<GenericResponse<ConfigurableService>>> =>
  new Promise<AxiosResponse<GenericResponse<ConfigurableService>>>((resolve, reject) => {
    const path = "/configurable-service";
    instance
      .get(path)
      .then(
        (response: AxiosResponse<GenericResponse<ConfigurableService>>) => {
          resolve(response);
        }
      )
      .catch((error: any) => {
        reject(error);
      });
  });

//-------------------------------------------------------------------------------------------------- Método para obtener lista de datos wifi del suscriptor

export const getListDataWifi = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseCustomizationWifi>>> =>
  new Promise<AxiosResponse<GenericResponse<ResponseCustomizationWifi>>>((resolve, reject) => {
    const path = "/support/wifi-list";
    instance
      .get(path, { params: { idCliente: idCliente } })
      .then(
        (response: AxiosResponse<GenericResponse<ResponseCustomizationWifi>>) => {
          resolve(response);
        }
      )
      .catch((error: any) => {
        reject(error);
      });
  });

export const getListWifiData = (
  idCliente: string
): Promise<AxiosResponse<GenericResponse<ResponseCustomizationWifi>>> =>
  new Promise<AxiosResponse<GenericResponse<ResponseCustomizationWifi>>>((resolve, reject) => {
    const path = "/support/wifi-list-dta";
    instance
      .get(path, { params: { idCliente: idCliente } })
      .then(
        (response: AxiosResponse<GenericResponse<ResponseCustomizationWifi>>) => {
          resolve(response);
        }
      )
      .catch((error: any) => {
        reject(error);
      });
  });

//-------------------------------------------------------------------------------------------------- Método para actualizar datos wifi del suscriptor

export const updateWifi = (
  idCliente: string,
  body: RequestUpdateWifi
): Promise<AxiosResponse<GenericResponse<GeneralResponse>>> =>
  new Promise<AxiosResponse<GenericResponse<GeneralResponse>>>((resolve, reject) => {
    const path = "/support/update-wifi";
    instance
      .post(path, body, { params: { idCliente: idCliente } })
      .then(
        (response: AxiosResponse<GenericResponse<GeneralResponse>>) => {
          resolve(response);
        }
      )
      .catch((error: any) => {
        reject(error);
      });
  });
